import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Scrolls to top on route change EXCEPT when navigation state.langSwitch === true.
export default function ScrollToTop() {
  const location = useLocation();
  const navType = useNavigationType();
  useEffect(() => {
    const isLangSwitch = location.state && location.state.langSwitch === true;
    if (isLangSwitch) return;
    // Only scroll on PUSH/REPLACE (not POP), so back button keeps position
    if (navType === "POP") return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [location.pathname, location.state, navType]);
  return null;
}
